/** Shared react-select styles for Widget Management / Live Chat settings */
export const widgetSelectStyles = {
	control: (provided, state) => ({
		...provided,
		minHeight: "38px",
		border: "1px solid #ddd",
		borderRadius: "6px",
		fontSize: "0.875rem",
		boxShadow: state.isFocused ? "0 0 0 2px rgba(0, 94, 255, 0.2)" : "none",
		borderColor: state.isFocused ? "#005EFF" : "#ddd",
		"&:hover": {
			borderColor: "#005EFF",
		},
	}),
	valueContainer: (provided) => ({
		...provided,
		padding: "4px 10px",
	}),
	input: (provided) => ({
		...provided,
		margin: "0px",
	}),
	indicatorSeparator: () => ({
		display: "none",
	}),
	indicatorsContainer: (provided) => ({
		...provided,
		paddingRight: "8px",
	}),
	menu: (provided) => ({
		...provided,
		fontSize: "0.875rem",
		zIndex: 5,
	}),
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? "#005EFF" : state.isFocused ? "#f8f9fa" : "white",
		color: state.isSelected ? "white" : "#333",
		fontSize: "0.875rem",
		padding: "8px 12px",
	}),
};
